import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CreditCardSvg from "../CreditCardSvg";

const Fees = () => {
  return (
    <section className="pt-3 pt-sm-8 pb-1 position-relative bg-gray-100">
      <div className="position-absolute w-100 z-index-1 top-0 mt-n3">
        <svg
          width="100%"
          viewBox="0 -2 1920 157"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>wave-down</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="#FFFFFF" fillRule="nonzero">
              <g id="wave-down">
                <path
                  d="M0,60.8320331 C299.333333,115.127115 618.333333,111.165365 959,47.8320321 C1299.66667,-15.5013009 1620.66667,-15.2062179 1920,47.8320331 L1920,156.389409 L0,156.389409 L0,60.8320331 Z"
                  id="Path-Copy-2"
                  transform="translate(960.000000, 78.416017) rotate(180.000000) translate(-960.000000, -78.416017) "
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="container mt-lg-5 mt-2 mt-md-4">
        <div className="mx-auto text-center">
          <h2 className="">Fees</h2>
          <Row>
            <Col xs={6} md={3}>
              <div className="info text-center">
                <CreditCardSvg className={"mx-auto"} />
                <p className={"font-weight-bold text-danger"}>
                  SM&E Fundamentals + GIS + 1 track =<br />
                  U.S. $ 3,850.00
                </p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="info text-center">
                <CreditCardSvg className={"mx-auto"} />
                <p className={"font-weight-bold text-danger"}>
                  GIS + 1 track =<br />
                  U.S. $ 3,100.00
                </p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="info text-center">
                <CreditCardSvg className={"mx-auto"} />
                <p className={"font-weight-bold text-danger"}>
                  Track only =<br />
                  U.S. $2,000.00
                </p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="info text-center">
                <CreditCardSvg className={"mx-auto"} />
                <p className={"font-weight-bold text-danger"}>
                  GIS only =<br />
                  U.S. $2,000.00
                </p>
              </div>
            </Col>
          </Row>
          <p className="z-index-3 position-relative">
            Fees include tuition, course materials, certificate accommodation,
            breakfast and lunch for the duration of the workshop. This does not
            include travel or other expenses. <br />
            <br />
            Applicants are advised to seek funding from their home organizations
            or from national or international agencies. <br />
            Those who have requested funding should submit their application
            forms to meet the deadline, and copies of application materials
            should be submitted directly to funding agencies. When funding has
            been confirmed, the applicant should contact the Ghana Field
            Epidemiology and Laboratory Training Programme (GFELTP) through the
            email provided as soon as possible. Due to the great demand for this
            workshop there is a limited spot available for (maximum 30
            participants).
          </p>
          <Card className={"card-plain"} style={{ zIndex: "9999" }}>
            <CardBody>
              <h5>Teaching Materials</h5>
              <p>
                All course materials will be provided as part of tuition. A
                laptop is required.
              </p>
            </CardBody>
          </Card>
        </div>
      </div>
      <div className="position-absolute w-100 bottom-0 mn-n1 z-index-0">
        <svg
          width="100%"
          viewBox="0 -1 1920 166"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>wave-up</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(0.000000, 5.000000)"
              fill="#f8f9fa"
              fillRule="nonzero"
            >
              <g id="wave-up" transform="translate(0.000000, -5.000000)">
                <path
                  d="M0,70 C298.666667,105.333333 618.666667,95 960,39 C1301.33333,-17 1621.33333,-11.3333333 1920,56 L1920,165 L0,165 L0,70 Z"
                  fill="#f8f9fa"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </section>
  );
};

export default Fees;
